export const textfieldStyles = {
  fontFamily: 'Inter',
  fontSize: '14px',
  linHeight: '146%',
  color: '#131F1E',

  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    background: '#fff',
    padding: '2px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #EDEFF7 !important',
    },
    '& fieldset': {
      border: 0,
    },
  },
  '& textarea': {
    padding: '12px',
    resize: 'vertical',
    maxHeight: '100px',
    minHeight: '60px',
    overflowX: 'hidden',
    overflowY: 'scroll !important',

    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },
};
